export class GateResolver {
  private gateMap: Map<string, (context: any) => boolean>;

  constructor() {
    this.gateMap = new Map<string, () => boolean>();
  }

  public setGate(gateReference: string, expression: (context: any) => boolean) {
    this.gateMap.set(gateReference, expression);
  }

  public testGate(gateReference: string): boolean {
    //console.log(`Testing gate ${gateReference}`);

    if (this.gateMap.has(gateReference)) {
      return this.gateMap.get(gateReference)!(null);
    } else {
      //console.warn(`Gate ${gateReference} cannot be resolved, rejecting.`);
      return false;
    }
  }
}

export interface IGateResolver<T> {
  setGate(reference: string, expression: (context: T) => boolean): void;

  testGate(reference: string): boolean;
}
